import{forwardRef as r}from"react";export function forwardRef(f){return r(f)}